import { GET_CUSTOMER_ACCOUNT, DELETE_BANK_DETAILS } from '../../actions/types';

const initialState = {
  customerAcct: []
};

const getCustomerAccounts = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_ACCOUNT:
      return {
        ...state,
        customerAcct: action.account
      };
    case DELETE_BANK_DETAILS:
      return state.customerAcct.customerAccounts.filter(item => item.id !== action.bankId);
    default: return state;
  }
};

export default getCustomerAccounts;
